import { Inject, Injectable } from '@angular/core';
import { DataKey } from '@core/models';
import { AppConfig, APP_CONFIG } from 'app/app.config';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(
    private tokenStorageService: TokenStorageService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {}

  saveUpdatedDataDate(key: DataKey): void {
    this.tokenStorageService.saveUpdatedDataDate(
      this.getDataExpiringDate(),
      key
    );
  }

  isStaleData(key: DataKey): boolean {
    return (
      new Date().getTime() > this.tokenStorageService.getStaleDataDate(key)
    );
  }

  private getDataExpiringDate(): number {
    return new Date().getTime() + this.appConfig.STALE_DATA_EXPIRED_TIME;
  }
}
